import axiosInsAcademy from '@/api/axios-ugems-academy';
import { GET_COURSE_BY_ID } from '@/api/master-data/course-catalog/course-catalog';

export default {
  // Get all courses for Mitra Attendance
  getCourses(params) {
    return axiosInsAcademy.get('/attendance/training', { params });
  },

  // Get course detail - using course-catalog API
  getCourseDetail(id) {
    return GET_COURSE_BY_ID(id);
  },

  // Get batches with attendance data for a course
  getBatches(courseId) {
    return axiosInsAcademy.get(`/attendance/training/${courseId}/batches`);
  },

  // Submit attendance for a batch (POST)
  submitAttendance(batchId, data) {
    return axiosInsAcademy.post(`/tna/partner/attendance/${batchId}`, data);
  },

  // Get attendance summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/hse/summary', { params });
  },

  // Download attendance template
  downloadTemplate(courseId) {
    return axiosInsAcademy.get(`/tna/partner/attendance/${courseId}/download-template`, {
      responseType: 'blob'
    });
  },

  // Upload attendance Excel file
  uploadAttendance(courseId, formData) {
    return axiosInsAcademy.post(`/tna/partner/attendance/${courseId}/upload-attendance`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Generate signed URL for attendance QR code
  generateSignedUrl(scheduleId) {
    return axiosInsAcademy.get(`/attendance/get-signed-url/${scheduleId}`);
  }
};
